import { BASE_URL } from '../config/env';


export function http({ path, method = 'POST', data = null, isFile = false }) {

    const config = {
        method,
        processData: false
    };

    if (data) {
        config['body'] = data;
    }

    const request = new Request(BASE_URL + path, config);

    return new Promise((resolve, reject) => {
        return fetch(request)
            .then(async response => {
                if (response.ok) {
                    let res;
                    if (isFile) {
                        res = await response.blob();
                    } else {
                        res = await response.json();
                    }
                    resolve(res);
                } else {
                    let res = await response.json();
                    if (res.hasOwnProperty('message')) {
                        res['message'] = res.message
                        reject(res);
                    } else {
                        reject(res.errorMessage)
                    }
                }


            })
            .catch((error) => {
                reject(error);
            });
    })
}
